import React, { useEffect } from "react";
import { Box, Typography, Button, Avatar } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import CallEndIcon from "@mui/icons-material/CallEnd";
import { useDispatch, useSelector } from "react-redux";
import { settings as s } from "../../../services/Settings";
import {
  getUsersById,
  addCallRecords,
  getMissedCallCount,
} from "../../../services/api/apiManager";
import addNotification from "react-push-notification";
import dayjs from "dayjs";
import avatarImg from "../../../../assets/img/Avatar.png";
import { useTwilio } from "../../../services/context/TwilioContext";
import {
  setMissedCallCount,
  setMissedCallParticipantId,
} from "../../../services/store/slice/CallSlice";
import {
  newCallLogs,
  SendCallAccept,
  ShowUserUnavaiableModel,
} from "../../../services/signalRService/signalRService";

function CallNotification() {
  const {
    setCallAccepted,
    incomingCall,
    setIncomingCall,
    chat_Id,
    setCallEnded,
  } = useTwilio();
  const dispatch = useDispatch();
  const { callStatus, sendCallChatId } = useSelector((state) => state.call);
  const user_id = localStorage.getItem("user_id");
  const GetCallerName =
    incomingCall?.parameters?.From?.split(":")[1] ||
    incomingCall?.parameters?.From;

  // Get User By Id data
  const [userById, setUserById] = React.useState([]);

  // For Add Record API if there is no action accept or reject k call
  const [timer, setTimer] = React.useState(null);
  useEffect(() => {
    if (incomingCall) {
      const timeout = setTimeout(() => {
        onDecline();
      }, 30000);

      setTimer(timeout);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [incomingCall]);

  // For Call logs Details API

  const inappPostedData = {
    CallId: 0,
    callType: "Single",
    callTitle: incomingCall?.message?.CallerName,
    CreatedBy: parseInt(user_id),
    STARTTIME: "00:00:00.0000000",
    ENDTIME: "00:00:00.0000000",
    CALLSTATUS: "Busy",
    DURATION: 0,
    ConversationId: chat_Id || sendCallChatId,
    callParticipants: [
      {
        userId: parseInt(user_id),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse: incomingCall?.direction,
        IsSeen: false,
      },
      {
        userId:
          incomingCall?.message?.To ||
          parseInt(incomingCall?.parameters?.From?.split(":")[1]),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse:
          incomingCall?.direction == "OUTGOING" ? "INCOMING" : "OUTGOING",
        IsSeen: true,
      },
    ],
  };

  // second Object For ExternalNumberCalling

  const inboundPostedData = {
    CallId: 0,
    callType: "Single",
    callTitle: "nothing",
    CreatedBy: parseInt(user_id),
    STARTTIME: "00:00:00.0000000",
    ENDTIME: "00:00:00.0000000",
    CALLSTATUS: "Busy",
    DURATION: 0,
    callParticipants: [
      {
        userId: parseInt(user_id),
        joinedAt:
          dayjs(new Date().toISOString()).format("HH:mm:ss.") +
          dayjs(new Date().toISOString())
            .millisecond()
            .toString()
            .padEnd(7, "0"),
        callResponse: incomingCall?.direction,
        ExternalPersonContactNo: incomingCall?.parameters?.From,
        CreatedBy: parseInt(user_id),
        IsSeen: false,
      },
    ],
  };
  //region addCallRecords
  const addCallRecordsApi = async () => {
    if (
      incomingCall?.direction == "INCOMING" &&
      incomingCall?.parameters?.From?.startsWith("+")
    ) {
      await addCallRecords(inboundPostedData);
      setCallEnded(true);
    } else {
      const resp = await addCallRecords(inappPostedData);
      if (resp?.data?.result?.callId) {
        newCallLogs(resp?.data?.result?.callId);
      }
      const respForAddCount = await getMissedCallCount(user_id);
      if (respForAddCount?.status == 200) {
        dispatch(setMissedCallCount(respForAddCount?.data?.count));
        dispatch(
          setMissedCallParticipantId(
            respForAddCount?.data?.result
              ?.map((data) => data?.cp?.callParticipantId)
              ?.toString()
          )
        );
      }
    }
  };

  useEffect(() => {
    const fetchToken = async (incomingCall) => {
      try {
        const response = await getUsersById(
          incomingCall?.parameters?.From?.split(":")[1]
        );
        handleNotifyFun(
          incomingCall?.parameters?.From?.startsWith("+")
            ? incomingCall.parameters.From
            : response?.data?.result[0]
        );
        if (response) {
          setUserById(response?.data?.result[0]);
        }
      } catch (error) {
        console.log(`Error:`, error);
      }
    };
    if (incomingCall || GetCallerName) {
      fetchToken(incomingCall);
    }
  }, [user_id, incomingCall]);
  // Accept incoming call
  const onAccept = async () => {
    if (incomingCall) {
      clearTimeout(timer);
      incomingCall.accept();
      SendCallAccept("Connected", parseInt(sendCallChatId), parseInt(user_id));
    }
  };

  // Reject incoming call
  const onDecline = async () => {
    if (incomingCall) {
      clearTimeout(timer);
      incomingCall.reject();
      addCallRecordsApi();
      setIncomingCall(null);
      setCallAccepted(false);
      setCallEnded(true);
      ShowUserUnavaiableModel(
        parseInt(user_id),
        parseInt(sendCallChatId),
        "Rejected"
      );
    }
  };

  // handle Notification Function
  const handleNotifyFun = (userById) => {
    let icon;
    if (userById?.profilePicPath) {
      icon = `<img src="${s.baseUrl}${userById.profilePicPath}" alt="${userById.firstName} ${userById.lastName}" style="width: 40px; height: 40px; border-radius: 50%;" />`;
    } else if (userById?.firstName && userById?.lastName) {
      const initials = `${userById.firstName.charAt(
        0
      )}${userById.lastName.charAt(0)}`;
      icon = `<div style="width: 40px; height: 40px; background-color: #4CAF50; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: bold;">${initials}</div>`;
    } else {
      icon = null;
    }

    addNotification({
      title: incomingCall?.parameters?.From?.startsWith("+")
        ? incomingCall.parameters.From
        : userById?.firstName && userById?.lastName
        ? `Incoming call from\n${userById.firstName} ${userById.lastName}`
        : null,
      message: callStatus,
      theme: "dark",
      position: "bottom-left",
      duration: 10000, // +123545454
      icon: userById?.profilePicPath
        ? `${s.baseUrl}${userById.profilePicPath}`
        : userById?.firstName?.charAt(0) && userById?.lastName?.charAt(0)
        ? userById.firstName.charAt(0) + userById.lastName.charAt(0)
        : typeof userById != "object"
        ? avatarImg
        : avatarImg,
      // : userById && userById.charAt(0),
      native: true,
      onClick: () => {
        window.moveTo(500, 100);
        window.focus();
      },
    });
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 16,
          left: "50%",
          transform: "translateX(-50%)",
          width: "80%",
          maxWidth: 300,
          bgcolor: "black",
          color: "#fff",
          borderRadius: 4,
          boxShadow: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "10px 20px",
          zIndex: 1300,
          gap: 2,
        }}
      >
        {/* Caller Avatar */}

        <Avatar
          sx={{
            width: 50,
            height: 50,
            mr: 2,
            objectFit: "cover",
          }}
          alt="Profile"
          src={
            userById?.profilePicPath
              ? `${s.baseUrl}${userById?.profilePicPath}`
              : undefined
          }
          loading="lazy"
        >
          {!userById?.profilePicPath &&
            userById?.firstName?.charAt(0) &&
            userById?.lastName?.charAt(0) &&
            userById?.firstName?.charAt(0).toUpperCase() +
              userById?.lastName?.charAt(0).toUpperCase()}
        </Avatar>

        {/* Caller Information */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Incoming call from
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {/* {userById?.firstName &&
              userById?.lastName &&
              `${userById.firstName} ${userById.lastName}`} */}
            {/* Suleman */}
            {incomingCall?.parameters?.From?.startsWith("+")
              ? incomingCall.parameters.From
              : userById?.firstName && userById?.lastName
              ? `${userById.firstName} ${userById.lastName}`
              : null}
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            color="success"
            startIcon={<CallIcon />}
            onClick={onAccept}
            sx={{
              minWidth: 40,
              padding: "5px 10px",
              backgroundColor: "#4caf50",
              "&:hover": {
                backgroundColor: "#43a047",
              },
            }}
          >
            Accept
          </Button>
          <Button
            variant="contained"
            color="error"
            startIcon={<CallEndIcon />}
            onClick={onDecline}
            sx={{
              minWidth: 40,
              padding: "5px 10px",
              backgroundColor: "#f44336",
              "&:hover": {
                backgroundColor: "#e53935",
              },
            }}
          >
            Decline
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default CallNotification;
